import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


export function candidateNumberValidator(country: string | (() => string)): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control?.value;
        let countryValue = country;
        if (typeof country === 'function') {
            countryValue = country();
        }
        if (countryValue !== 'NG') {
            return null; // Only validate for Nigeria
        }
        const isTenDigits = /^\d{10}$/.test(value);
        const startsWithValidDigit = /^[45]/.test(value);
        const prefix = parseInt(value?.substring(0, 3), 10);
        const isValidPrefix = (prefix >= 401 && prefix <= 438) || (prefix >= 501 && prefix <= 538);
        return isTenDigits && startsWithValidDigit && isValidPrefix 
            ? null
            : {invalidCandidateNumber: true };
    }
}